import React from 'react';
import styled from 'styled-components';
import MotifBreadcrumb from '@ey/motif-react-wrapper/Breadcrumb';

export default function Breadcrumb(props) {
	const {id, className, firstItemsAmount, lastItemsAmount, maxItems, triggerButtonProps, children} = props;
	return (
		<StyledMotifBreadcrumb
			id={id}
			className={className}
			firstItemsAmount={firstItemsAmount}
			lastItemsAmount={lastItemsAmount}
			maxItems={maxItems}
			triggerButtonProps={triggerButtonProps}
		>
			{children}
		</StyledMotifBreadcrumb>
	);
}

const StyledMotifBreadcrumb = styled(MotifBreadcrumb)``;
